'use client';
var classes = {"root":"m-b6d8b162"};

export { classes as default };
//# sourceMappingURL=Text.module.css.mjs.map
